import { reduce } from './';
var blockquote = function blockquote(node, schema) {
  var result = [];
  node.content.forEach(function (n) {
    result.push(reduce(n, schema));
  });
  return "> ".concat(result.join(''));
};
export default blockquote;